import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  userList,
  userGet,
  userReset,
  userCreate,
  userUpdateAndList,
  userDelete,
  userToggleEnable,
  userImpersonate,
  usersReset
} from '../../redux/actions'

import {
  preparePager,
  prepareSearch
} from '../../common/tabletools'

import history from '../../history'
import Users from '../../components/users'
import NoData from '../../components/nodata'

class UsersPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      pager: {
        defaultColumns: ['firstname', 'lastname', 'customer_name', 'role', 'language', 'email'],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
    }
  }

  componentWillMount() {
    this.props.getUsers(this.state.pager)
  }

  fetch = (table) => {
    const { pager } = this.state
    if (!pager.global)
    this.props.getUsers(preparePager(table, pager))
    else {
      let search = pager.search
      let pagers = preparePager(table, pager)
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search]
      }
      else {
        pagers.search = search
      }
      this.props.getUsers(pagers)
    }
  }

  search = (term) => {
    const { users } = this.props
    const { columns } = users
    const { pager } = this.state
    const _pager = prepareSearch(term, columns, pager)
    _pager.global = term === '' ? false : true
    this.setState({
      pager: _pager
    })
    this.props.getUsers(_pager)
  }
  getUser(id) {
    this.props.getUser(id)
  }
  resetUser() {
    this.props.resetUser()
  }
  deleteUser(id) {
   return this.props.del(id, this.state.pager)
  }
  toggleEnable(id, enabled) {
    this.props.toggleEnable(id, enabled, this.state.pager)
  }
  render() {

    const {
      translate,
      languages,
      users,
      user,
      impersonationRequest,
      error,
      errorMessage,
      create,
      update,
      profile,
      location

    } = this.props

    const {
      pager
    } = this.state

    return (
      (users) ? (
        <Users
          translate={translate}
          languages={languages}
          users={users}
          user={user}
          profile={profile}
          impersonationRequest={impersonationRequest}
          pager={pager}
          fetch={this.fetch}
          search={this.search}
          get={this.getUser.bind(this)}
          reset={this.resetUser.bind(this)}
          create={create}
          update={update}
          del={this.deleteUser.bind(this)}
          toggleEnable={this.toggleEnable.bind(this)}
          error={error}
          errorMessage={errorMessage}
          viewingAllUsers={location.pathname.indexOf("allusers") >= 0 ? true : false}
        />
      ) : (null)
    )
  }

  componentWillUnmount() {
    this.props.resetUsers()
    const { user, getUser, currentLoggedInUserId } = this.props
    if (!user || (user && user.id !== currentLoggedInUserId)) {
     getUser(currentLoggedInUserId)
    }
  }

}

const mapDispatchToProps = (dispatch, props) => ({
  getUsers: (pager) => {
    dispatch(userList(pager, 0, props));
  },
  getUser: (id) => {
    if (id !== null) {
      dispatch(userGet(id))
    }
  },
  resetUser: () => {
    dispatch(userReset())
  },
  create: (user, pager) => {
    return dispatch(userCreate(user, pager))
  },
  update: (user, pager) => {
    return dispatch(userUpdateAndList(user, pager, props))
  },
  del: (id, pager) => {
    return dispatch(userDelete(id, pager, props))
  },
  toggleEnable: (id, enabled, pager) => {
    dispatch(userToggleEnable(id, enabled, pager, props))
  },
  impersonationRequest: (request) => {
    dispatch(userImpersonate(request)).then((response) => {
      let data = response.payload.data
      const { token, name, customer, roles } = data
      const url = `/impersonate?token=${token}&name=${name}&customer=${customer}&roles=[${roles}]`
      history.replace(url, true)
    })
  },
  resetUsers: () => {
    dispatch(usersReset())
  }
})

const mapStateToProps = (state) => ({
  users: state.userReducer.users,
  user: state.userReducer.user,
  languages: state.localeReducer.languages,
  error: state.userReducer.error,
  errorMessage: state.userReducer.errorMessage,
  profile: state.profileReducer.profile,
  currentLoggedInUserId: state.userReducer.currentLoggedInUserId,
  ...state,
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersPage)
